import React from "react";
import Dropzone from "react-dropzone";
import { ReadFileExcel } from "../../../../../lib/ReadFileExcel";
import "./dragmass.scss";

interface Props {
  onComplete: (e: any) => void;
  loading: boolean;
  setLoading: (e: boolean) => void;
}

export function DragMassUpload(props: Props) {
  const onDrop = async (acceptedFiles: any[]) => {
    await props.setLoading(true);
    const res = new Promise((r) => {
      ReadFileExcel(acceptedFiles[0], (callback) => {
        r(callback);
      });
    });

    props.onComplete(await res);
    props.setLoading(false);
  };

  return (
    <Dropzone onDrop={onDrop}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <section>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div className="ant-upload ant-upload-drag form-secondary">
              <span className="ant-upload ant-upload-btn">
                <div className="ant-upload-drag-container">
                  <p className="ant-upload-drag-icon">
                    <i className="os-icon os-icon-inbox anticon"></i>
                  </p>
                  <p className="ant-upload-text">Click or drag XLSX file to this area to upload</p>
                  <p className="ant-upload-hint">
                    Must contain <code>excel</code> file.
                  </p>
                </div>
              </span>
            </div>
          </div>
        </section>
      )}
    </Dropzone>
  );
}
